module.exports = __webpack_public_path__ + "resources/img/ic-en.5e3474c0.png";